import React from "react";
import { ConfigProvider } from "antd";
import { dashboardTheme } from "../../theme/dashboardTheme";
import { neutral, spacing } from "../../theme/tokens";
import PageHeader from "../PageLayout/PageHeader";

const BrandedPageLayout = ({
  children,
  title,
  subtitle,
  breadcrumbItems = [],
  extra,
}) => {
  return (
    <ConfigProvider theme={dashboardTheme}>
      <div style={{ background: neutral[50], minHeight: "100vh" }}>
        <PageHeader
          title={title}
          subtitle={subtitle}
          breadcrumb={breadcrumbItems}
          extra={extra}
        />
        <div style={{ padding: `${spacing[6]}px ${spacing[6]}px ${spacing[8]}px` }}>
          {children}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default BrandedPageLayout;
